import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import ProductLogo from 'account/ProductLogo'

import getDiscountCodeInfo, { DiscountInfo } from 'core/application/account/discountCodeInfo'
import { GetProductsToBuyResponse } from 'core/application/adminDashboard/ourProducts/productsToBuy'

import useSwitchProduct from 'common/hooks/useSwitchProduct'

import { Alert, Button, Card, Col, Icon } from 'common/components'

import { useQueryRequest, useQueryRequestV2 } from '../../../common/hooks'
import PurchaseProductModal from './PurchaseProductModal'

type ProductCardProps = { product: GetProductsToBuyResponse; isCurrent: boolean }

const ProductCard = ({ product, isCurrent }: ProductCardProps) => {
  const { t: translate } = useTranslation()
  const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false)
  const { data: discount, sendQuery: sendGetDiscountInfo } = useQueryRequestV2<DiscountInfo>()

  const handleSwitch = () => {
    window.location.reload()
  }

  useEffect(() => {
    if (product.defaultCrossSaleDiscountCode) {
      ;(async () => {
        await sendGetDiscountInfo(() => getDiscountCodeInfo(product.defaultCrossSaleDiscountCode))
      })()
    }
  }, [product.defaultCrossSaleDiscountCode])

  const { handleSwitchProduct, loading } = useSwitchProduct(handleSwitch)

  const handlePurchaseModal = async (isOpen: boolean) => {
    setIsPurchaseModalOpen(isOpen)
  }

  const handleCloseModal = () => {
    setIsPurchaseModalOpen(false)
  }

  const handleLearnMore = (productId: number) => {
    switch (productId) {
      case 1:
        window.open('https://www.peoplekeep.com/product/ichra', '_blank')
        break
      case 2:
        window.open('https://www.peoplekeep.com/product/qsehra', '_blank')
        break
      case 3:
        window.open('https://www.peoplekeep.com/product/gchra', '_blank')
        break
      case 4:
        window.open('https://www.peoplekeep.com/product/workperks', '_blank')
        break
    }
  }

  return (
    <Col xs={24} sm={12}>
      <Card className={`${isCurrent ? 'bg-green-1 border-color-green-3' : ''} t-product-${product.id}`}>
        <div className="mb-16">
          <ProductLogo shortGchra productId={String(product.id)} />
        </div>
        <div className="font-12 color-gray-8 mb-16">{product.description}</div>
        {product.isInUse ? (
          <div className="flex flex__space_between flex__align_center">
            <div className="flex flex__align_center color-green-6 py-6">
              <Icon type="far fa-check-circle" className="mr-4" fontAwesome />
              {translate('admin-dashboard.our-products.own-product')}
            </div>
            {!isCurrent && (
              <Button
                className={'t-switch-to-product'}
                onClick={() => handleSwitchProduct(product.companyId, product.id)}
                type="default"
              >
                Switch to {product.name}
              </Button>
            )}
          </div>
        ) : (
          <>
            {discount && discount.pageDescription && (
              <Alert type={'success'} className={'mb-16'} message={discount.pageDescription} />
            )}
            <div className="flex">
              <Button type="primary" className="mr-8 t-purchase-product" onClick={() => handlePurchaseModal(true)}>
                {translate('admin-dashboard.our-products.purchase-product')}
              </Button>
              <Button
                type="default"
                icon="fas fa-external-link"
                iconPosition="right"
                onClick={() => handleLearnMore(product.id)}
              >
                Learn more
              </Button>
            </div>
          </>
        )}

        <PurchaseProductModal
          isOpen={isPurchaseModalOpen}
          onClose={handleCloseModal}
          subscriptionPackageCode={product.subscriptionPackageId}
          switchToProduct={() => handleSwitchProduct(product.companyId, product.id)}
          switchLoading={loading}
          product={product}
        />
      </Card>
    </Col>
  )
}

export default ProductCard
